import { auth } from "@strapi/helper-plugin";

const baseObject = { Authorization: '' };

const handler = {
  get(_, prop) {
    if (prop === 'Authorization') {
      return `bearer ${auth.getToken()}`;
    }
  },
};

const authorizationHeader = new Proxy(baseObject, handler);

export default authorizationHeader;
